class WelcomeOfferProductCard extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.variantId = this.getAttribute('data-variant-id');
    this.productTitle = this.getAttribute('data-product-title');
    this.productColor = this.getAttribute('data-product-color');
    this.productImage = this.getAttribute('data-product-image');
    this.productHandle = this.getAttribute('data-product-handle');

    this.onAddClick = this.onAddClick.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
    this.onMoreInfoClick = this.onMoreInfoClick.bind(this);
  }

  static get observedAttributes() {
    return ['quantity', 'bundle-size'];
  }

  get quantity() {
    return parseInt(this.getAttribute('quantity')) || 0;
  }
  set quantity(val) {
    const n = Number(val);
    if (!isNaN(n) && n >= 0) this.setAttribute('quantity', n);
  }

  get bundleSize() {
    return parseInt(this.getAttribute('bundle-size')) || 0;
  }
  set bundleSize(v) {
    const n = Number(v);
    if (!isNaN(n) && n >= 0) this.setAttribute('bundle-size', n);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal === newVal) return;
    if (name === 'quantity' || name === 'bundle-size') {
      this.renderFooter();
    }
  }

  connectedCallback() {
    this.infoButton = this.querySelector('.welcome-offer-builder__info_button');
    this.infoButton?.addEventListener('click', this.onMoreInfoClick);
    this.renderFooter();
  }

  disconnectedCallback() {
    this.infoButton?.removeEventListener('click', this.onMoreInfoClick);
  }

  /**
   * Batch-update multiple attributes at once.
   * @param {Object} props — key/value pairs to set as attributes
   */
  updateProperties(props = {}) {
    Object.entries(props).forEach(([key, val]) => {
      if (key in this) this[key] = val;
      else this.setAttribute(key, val);
    });
    //this.renderFooter();
  }

  renderFooter() {
    const footerCta = this.querySelector('.welcomer-offer-builder__product-card__cta_wrapper');
    if (!footerCta) return;
    footerCta.innerHTML = '';

    const qty = this.quantity;
    const max = this.bundleSize;
    if (qty === 0) {
      const btn = document.createElement('button');
      btn.className = 'button button--primary';
      btn.textContent = 'Add';
      btn.disabled = max >= 2;
      btn.setAttribute('aria-label', `Add product ${this.productId}`);
      btn.addEventListener('click', this.onAddClick);
      footerCta.appendChild(btn);
    } else {
      const wrapper = document.createElement('div');
      wrapper.className = 'welcome-offer-quantity-wrapper button';
      const minus = document.createElement('button');
      minus.textContent = '–';
      minus.setAttribute('aria-label', `Remove one of ${this.productId}`);
      minus.addEventListener('click', this.onRemoveClick);

      const span = document.createElement('span');
      span.textContent = ` ${qty} `;
      span.className = 'quantity-display';

      const plus = document.createElement('button');
      plus.textContent = '+';
      plus.disabled = max >= 2;
      plus.setAttribute('aria-label', `Add one more of ${this.productId}`);
      plus.addEventListener('click', this.onAddClick);

      wrapper.append(minus, span, plus);
      footerCta.appendChild(wrapper);
      // footerCta.append(minus, span, plus);
    }
  }
  onAddClick() {
    //console.log('Adding item:', this.productId, this.variantId);
    /*
    console.log({
      detail: {
        productId: this.productId,
        variantId: this.variantId,
        productTitle: this.productTitle,
        productColor: this.productColor,
        productImage: this.productImage,
      },
      bubbles: true,
      composed: true,
    });
    */
    this.dispatchEvent(
      new CustomEvent('welcome-offer-add-item', {
        detail: {
          productId: this.productId,
          variantId: this.variantId,
          productTitle: this.productTitle,
          productColor: this.productColor,
          productImage: this.productImage,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  onRemoveClick() {
    this.dispatchEvent(
      new CustomEvent('welcome-offer-remove-item', {
        detail: {
          productId: this.productId,
          variantId: this.variantId,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  onMoreInfoClick(event) {
    event.preventDefault();
    const moreInfoPanel = document.querySelector('more-info-panel');
    if (!moreInfoPanel) return;
    moreInfoPanel.updateProperties({
      productHandle: this.productHandle,
    });

    moreInfoPanel
      .loadMainProduct()
      .then(() => {
        moreInfoPanel.open(this);
      })
      .catch((err) => {
        console.error('Error loading product info:', err);
      });
  }
}
customElements.define('welcome-offer-product-card', WelcomeOfferProductCard);
